import { PlatformAppsApiClient } from '@fourthwall/services/dist/PlatformAppsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'
import { useQueryClient } from '@tanstack/react-query'

const useUpdatePlatformAppClientRedirectUrisMutation = createMutationHook(
  PlatformAppsApiClient.updatePlatformAppClientRedirectUris,
  {
    mutationKey: ['updatePlatformAppClientRedirectUris'],
  },
)

export const useUpdatePlatformAppClientRedirectUris = () => {
  const queryClient = useQueryClient()
  const { updatePlatformAppClientRedirectUrisMutation } =
    useUpdatePlatformAppClientRedirectUrisMutation({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['platformAppClients'] })
        queryClient.invalidateQueries({ queryKey: ['platformAppClient'] })
      },
    })

  return {
    updatePlatformAppClientRedirectUris: updatePlatformAppClientRedirectUrisMutation.mutate,
    isLoading: updatePlatformAppClientRedirectUrisMutation.isLoading,
  }
}
